import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Text } from '@rebass/emotion';

const FormTitleStyle = () => css`
  margin: 0;
  opacity: 0.37;
  text-transform: uppercase;
  display: inline;
`;

const FormTitle = styled(Text)`
  ${FormTitleStyle}
`;

export default FormTitle;
